import React from 'react';
import _ from 'lodash';

import { skeleton as Skeleton } from '@breezeway/brzw-components';

import './multiple_skeleton.scss';

const CLASS_NAME = 'multiple-skeleton';

const MultipleSkeleton = () => (
  <div className={CLASS_NAME}>
    {_.map(new Array(4), (item, index) => (
      <Skeleton.SkeletonBar
        className={`${CLASS_NAME}__bar`}
        key={index}
        theme={Skeleton.constants.SKELETON_THEMES.GRAY_LIGHT}
      />
    ))}
  </div>
);

export default MultipleSkeleton;
